import {createContext} from 'react';
import {ReactReduxContextValue} from 'react-redux';

export const EDTContext = createContext<ReactReduxContextValue | null>(null);
